module.exports = __webpack_public_path__ + "img/icon.a7f1ded5.png";